import {$message, $messageLoad, $messageContainer} from './common/message/message';
import {$stemplateAddRender} from './common/render/render';
import {$stemplateLoad} from './controllers/load/loaded';
import * as $ from 'jquery';
import {$subscriber} from 'fire-wind-water';
import {triggerNav, checkedNav} from './components/nav';
import {initCarousel as $skInitSwiper, destroyCarousel as $skDestroySwiper} from './components/carousel';
import {initMimage as $skInitMimage, destroyMimage as $skDestroyMimage} from './components/mimage';
import {Swiper} from 'swiper';
import {createError, getFieldEvent} from './controllers/events/field-ev';
import {fieldOperate} from './controllers/events/field-ev';
import {$hfsDatePicker} from '../../date';
import {customSave} from './modules/customform';

export const $sk = {
  $message,
  $messageLoad,
  $messageContainer,
  $stemplateLoad,
  $stemplateAddRender,
  $skInitSwiper,
  $skDestroySwiper,
  $skInitMimage,
  $skDestroyMimage,

  createError,
  getFieldEvent,
  // listInput,
  // listOtherInput,
  // selectMenu,
  // setSelectedValue,
  ...fieldOperate,
  customSave
};

export {
  $,
  Swiper,
  $subscriber,
  triggerNav,
  checkedNav,
  $hfsDatePicker
};
